<div class="free-trial-container" [class.disabled]="disabled">
    <label class="toggle-switch">
      <input [disabled]="disabled" type="checkbox" (change)="onChange()" [checked]="checked">
      <span class="toggle-slider"></span>
    </label>
    <div class="free-trial-text d-flex flex-column flex-sm-row align-items-md-center align-items-start">
      <h2 class="title me-4 demiBold">Free Trial</h2>
      <p class="description normal">{{ message }}</p>
    </div>
  </div>
